import { render, staticRenderFns } from "./action-score-faqs.vue?vue&type=template&id=31e1c26e&scoped=true&"
import script from "./action-score-faqs.vue?vue&type=script&lang=js&"
export * from "./action-score-faqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e1c26e",
  null
  
)

export default component.exports